<div class="source-container">
  <div id="assessment-details" class="row">
    <div class="col-md-12 col-lg-12 col-xl-12">
      <div class="container-fluid">
        <div class="row row-head-right d-flex align-items-center flex-nowrap py-3 pr-3 px-lg-4">
          <div class="select-all-checkbox ml-lg-2">
            <app-checkbox
              [ariaLabel]="'Select all questions for Add From'"
              #selectAllCheckbox
              class="select-checkbox"
              [ariaChecked]="selectAllAriaChecked"
              [checked]="title.selected"
              (change)="selectAll($event)"
            ></app-checkbox>
          </div>
          <div class="d-flex question-head ml-lg-3">
            <span>Question</span>
            <button class="shortcuts-info-btn" aria-haspopup="dialog" (click)="shortcutsModalIsVisible = true" appTooltip="Information - Keyboard Shortcuts" alternateAriaLabel="Information Keyboard shortcuts for adding and reordering questions">
              <i class="fa fa-info-circle fa-fw bank-info-icon"></i>
            </button>
          </div>
          <div class="p-0 ml-auto d-flex flex-nowrap align-items-center question-head">
            <span class="text-nowrap"
              >{{ totalQuestion }} Questions</span
            >
            <div 
              id="search-results-status-left"
              class="sr-only"
              aria-live="polite"
              aria-atomic="true">
              {{ searchResultsAnnouncement }}
            </div>
            <app-button
              class="expand-all-button p-0 pl-4"
              [buttonText]="ExpandToggleText"
              [purpose]="_buttonPurpose.Secondary"
              (click)="expandAllToggle()"
            ><span class="sr-only">for Add From</span></app-button>
            <button
              type="button"
              [appTooltip]="ExpandToggleText"
              [alternateAriaLabel]="ExpandToggleText + ' for Add From'"
              class="btn btn-secondary expand-all-icon-button m-0 ml-2"
              [ngClass]="hasExpanded ? 'icon-collapse' : 'icon-expand'"
              (click)="expandAllToggle(false)"
            ></button>
          </div>
        </div>
      </div>
      <div
        class="container-fluid auto-overflow source-bank"
        *ngIf="questionList && questionList.itemInfo.questions"
        [style.height.px]="sourcePickerCompHeightBody"
        cdkDropList
        id="leftList"
        #leftList
        [cdkDropListData]="questionList.itemInfo.questions"
        [cdkDropListConnectedTo]="['test-panel']"
        [cdkDropListSortingDisabled]="true"
        (cdkDropListDropped)="drop($event)"
        cdkDropListHasAnchor
        [cdkDropListEnterPredicate]="noReturnPredicate"
      >
        <div class="container-fluid display-result" *ngIf="searchedText != ''">
          <Strong
            >Displaying {{ totalSearchCount }} results for "{{
              searchedText
            }}"</Strong
          >
        </div>
      <ul class="question-list-ul">
        <ng-container *ngFor="let question of currentPage(); let i = index">
          <li
            class="row"
            [ngClass]="{
              'line-divider': i == 0,
              'question-dropped': similarQuestionsBothPanel.includes(
                question.qid
              ),
              'questions-unused': !similarQuestionsBothPanel.includes(
                question.qid
              ),
              'temp-drag-state': grabbedIndex === i && temporaryStateForAdd
            }"
            cdkDrag
            [cdkDragDisabled]="isModalOpen"
            [cdkDragData]="question"
            (cdkDragStarted)="sourceDrag.emit(true)"
            (cdkDragEnded)="sourceDrag.emit(false)"
          >
            <div
              class="container-fluid border-bottom"
              [ngClass]="
                question.selected ? 'question-list selectedTd' : 'question-list'
              "
            >
              <div class="row" [id]="`setQuestionDiv${i}`">
                <div class="col-1 p-0 m-0 select-div">
                  <div class="row m-0 h-100 flex-nowrap">
                    <div
                      class="col-auto p-1 m-1 select-div-item drag-handle-div"
                      [class.grabbed-state]="grabbedIndex === i && !temporaryStateForAdd"
                    >
                      <div
                        class="handles"
                        role="button"
                        [class.no-focus-outline]="temporaryStateForAdd && grabbedIndex === i"
                        [alternateAriaLabel]="'Move question handler for ' + question.title"
                        [attr.aria-pressed]="grabbedIndex === i"
                        tabindex="0"
                        appTooltip="Move question handler"
                        [parent]="leftList"
                        (click)="dragHandleClicked(question, i)"
                        (keydown)="dragHandlerKeydown($event, question, i)">
                          <i
                            class="dpg-icon snowflakes-align"
                            [ngClass]="{
                              'dpg-icon-movingtile': grabbedIndex !== i || temporaryStateForAdd,
                              'dpg-icon-movingtile-white': grabbedIndex === i && !temporaryStateForAdd
                            }"
                          ></i>
                      </div>
                      <div class="sr-only" role="status">{{ grabbedIndex === i ? question.title + ' handler selected' : '' }}</div>
                      <div class="sr-only" role="status">{{ deselectedIndex === i ? question.title + ' handler deselected' : '' }}</div>
                    </div>
                    <div class="col-6 p-0 m-0 select-div-item">
                      <app-checkbox
                        class="select-checkbox checkbox-td"
                        [checked]="question.selected"
                        (change)="OnCheckboxSelect(question, $event)"
                        [ariaLabel]="question.title"
                      ></app-checkbox>
                    </div>
                  </div>
                </div>
                <div class="col-11 pl-2 display-text" title="{{ question.title }}">
                  <div class="row top-13 pl-4 mr-0">
                    <div class="title-div mr-auto question-type-container">
                      <span class="pill-btn height-20 btn-sm btn-primary">
                        {{ question.typeDesc }}
                      </span>
                      <span
                        *ngIf="question.algo"
                        class="pill-btn height-20 btn-sm btn-primary"
                      >
                        Algorithmic
                      </span>
                    </div>
                    <div
                      class="question-edit text-right pr-0 d-flex align-items-center justify-content-end"
                    >
                      <span
                        *ngIf="similarQuestionsBothPanel.includes(question.qid)"
                      >
                        <i
                          class="dpg-icon dpg-icon-input-success"
                          [ngClass]="!question.userEdited ? 'assign-left' : ''"
                          title="Selected Question"
                          aria-hidden="true"
                        ></i>
                        <span class="sr-only">Selected</span>
                      </span>
                      <div
                        *ngIf="!question.userEdited"
                        class="inline-display"
                        (click)="setKebabIndex(i)"
                      >
                        <kebab-component
                          [show_kebab]="i === kebabIndex"
                          [kebabMenuItems]="moveToTestPanelKebabMenu"
                          [collection]="question"
                          [parentContainer]="leftList"
                          (addToTestPanel)="addToTest(question)"
                          (closeKebabOnEscape)="kebabIndex = -1"
                          [alternateAriaLabel]="'Options for ' + question.title"
                          (modalStateChanged)="onModalStateChanged($event)"
                        >
                        </kebab-component>
                      </div>
                      <div
                        *ngIf="question.userEdited"
                        class="inline-display"
                        (click)="setKebabIndex(i)"
                      >
                        <kebab-component
                          *ngIf="question.edited == 0"
                          [question-source]="false"
                          [collection]="question"
                          [show_kebab]="i === kebabIndex"
                          [disableDelete]="true"
                          [question-source]="true"
                          [kebabMenuItems]="sectionBreakNoDeleteKebabMenu"
                          [parentContainer]="leftList"
                          [last_kebab]="
                            kebabIndex === arrayIndex - 1 && kebabIndex > 2
                          "
                          (softDelete)="deleteQuestion($event)"
                          (emitItemInfo)="emitQuestionInfo($event)"
                          (emitQuestionUpdate)="sourceQuestionUpdate($event)"
                          (closeKebabOnEscape)="kebabIndex = -1"
                          (addToTestPanel)="addToTest(question)"
                          [alternateAriaLabel]="'Options for ' + question.title"
                          (modalStateChanged)="onModalStateChanged($event)"
                        >
                        </kebab-component>
                        <kebab-component
                          *ngIf="question.edited == 1"
                          [question-source]="false"
                          [collection]="question"
                          [show_kebab]="i === kebabIndex"
                          [disableDelete]="true"
                          [question-source]="true"
                          [kebabMenuItems]="sectionBreakKebabMenu"
                          [parentContainer]="leftList"
                          [last_kebab]="
                            kebabIndex === arrayIndex - 1 && kebabIndex > 2
                          "
                          (softDelete)="deleteQuestion($event)"
                          (emitItemInfo)="emitQuestionInfo($event)"
                          (emitQuestionUpdate)="sourceQuestionUpdate($event)"
                          (closeKebabOnEscape)="kebabIndex = -1"
                          (addToTestPanel)="addToTest(question)"
                          [alternateAriaLabel]="'Options for ' + question.title"
                          (modalStateChanged)="onModalStateChanged($event)"
                        >
                        </kebab-component>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 top-3">
                      <span
                        class="title-question"
                        title="{{ question.title }}"
                        [innerHtml]="
                          question.title | truncate : [[truncateTitle], '...']
                        "
                        aria-level="3"
                        role="heading"
                      ></span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 left-side-question">
                      <source-question
                        [question-preview]="question.preview"
                        [index-item]="question.qid + '-main'"
                        [question-index]="i"
                        [ref-type]="question.refType"
                        [head-question]="headQuestion"
                        [question-hidden-array]="questionHideArray"
                        (toggleQuestionHideArrayClicked)="
                          toggleQuestionHideArray($event)
                        "
                        [source]="'source-bank'"
                        [question-title]="question.title"
                        [expandAllObservable]="expandAllSubject.asObservable()"
                      >
                      </source-question>
                    </div>
                  </div>
                  <div
                    *ngIf="question.refType == 'multipart'"
                    class="multipart"
                  >
                    <ng-container
                      *ngFor="
                        let questionPart of question.parts;
                        let questionId = index
                      "
                    >
                      <div class="container-fluid multipart-div border-div">
                        <div class="row">
                          <div class="title-div col-md-10">
                            <span
                              class="pill-btn height-20 btn-sm btn-primary"
                            >
                              {{ questionPart.typeDesc }}
                            </span>
                            <span
                              *ngIf="question.algo"
                              class="pill-btn height-20 btn-sm btn-primary"
                            >
                              Algorithmic
                            </span>
                          </div>
                          <div class="col-2" *ngIf="question.userEdited">
                            <div
                              id="{{ indexCal(i, questionId) }}"
                              (click)="setKebabIndex(indexCal(i, questionId))"
                            >
                              <kebab-component
                                *ngIf="questionPart.edited == 1"
                                [question-source]="true"
                                (softDelete)="deleteQuestion($event)"
                                [selectedQuestion]="question"
                                [collection]="questionPart"
                                [parentContainer]="leftList"
                                [show_kebab]="
                                  indexCal(i, questionId) === kebabIndex
                                "
                                [disableDelete]="true"
                                [kebabMenuItems]="partQuestionKebabMenu"
                                [last_kebab]="
                                  kebabIndex === arrayIndex - 1 &&
                                  kebabIndex > 2
                                "
                                (emitQuestionUpdate)="
                                  sourceQuestionUpdate($event)
                                "
                                (emitItemInfo)="emitQuestionInfo($event)"
                                (closeKebabOnEscape)="kebabIndex = -1"
                                [alternateAriaLabel]="'Options for ' + questionPart.title"
                                (modalStateChanged)="onModalStateChanged($event)"
                              >
                              </kebab-component>

                              <kebab-component
                                *ngIf="questionPart.edited == 0"
                                [question-source]="true"
                                [collection]="questionPart"
                                [parentContainer]="leftList"
                                [show_kebab]="
                                  indexCal(i, questionId) === kebabIndex
                                "
                                [disableDelete]="true"
                                [kebabMenuItems]="partQuestionNoDeleteKebabMenu"
                                [last_kebab]="
                                  kebabIndex === arrayIndex - 1 &&
                                  kebabIndex > 2
                                "
                                (emitQuestionUpdate)="
                                  sourceQuestionUpdate($event)
                                "
                                (emitItemInfo)="emitQuestionInfo($event)"
                                (closeKebabOnEscape)="kebabIndex = -1"
                                [alternateAriaLabel]="'Options for ' + questionPart.title"
                                (modalStateChanged)="onModalStateChanged($event)"
                              >
                              </kebab-component>
                            </div>
                          </div>
                        </div>
                        <div>
                          <span
                            class="title-question"
                            title="{{ questionPart.title }}"
                            [innerHtml]="
                              questionPart.title
                                | truncate : [[truncateTitle], '...']
                            "
                            aria-level="4"
                            role="heading"
                          ></span>
                        </div>
                        <source-question
                          [multiple-part]="true"
                          [question-preview]="questionPart.preview"
                          [ref-type]="questionPart.refType"
                          [index-item]="questionPart.qid + '-parts'"
                          [question-index]="i"
                          [head-question]="headQuestion"
                          [question-hidden-array]="questionHideArray"
                          (toggleQuestionHideArrayClicked)="
                            toggleQuestionHideArray($event)
                          "
                          [source]="'source-bank'"
                          [question-title]="questionPart.title"
                          [expandAllObservable]="expandAllSubject.asObservable()"
                        >
                        </source-question>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ng-container>
        </ul>
      </div>
      <div id="pager-example " class="border-question-pager">
        <app-pager
          class="d-flex flex-column flex-md-row align-items-center justify-content-start"
          [length]="totalLength"
          [pageSize]="pageSize"
          (page)="fetchPage($event)"
          [ariaLabel]="'Pagination for questions in Add From Section'"
        >
        </app-pager>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="showQuestionDelete"
  class="ahe-ui-alert-modal"
  id="previewModal1"
  role="dialog"
  tabindex="-1"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  (keydown.escape)="checkTooltipPresent() ? null : closeDeleteModal()"
  aria-labelledby="deleteQuestionTitle"
>
  <div class="modal-overlay" id="previewModalOverlay1111">
    <div class="modal-container-new">
      <div class="modal-dialog-copy">
        <div class="modal-content">
          <div class="modal-header-new">
            <h2 id="deleteQuestionTitle" class="modal-title">Delete Question</h2>
            <button
              app-button
              appTooltip="Close"
              aria-label="close dialog"
              class="close"
              data-dismiss="modal"
              type="button"
              (click)="closeDeleteModal(true)"
            >
              <span class="ahe-icon ahe-icon-close-white"></span>
            </button>
          </div>
          <div class="modal-body-new">
            <div class="question-body">
              <div class="div-cont">
                <div class="child-cont-1">
                  <i class="dpg-icon-system-alert-warning"></i>
                </div>
                <div class="child-cont-2" *ngIf="deleteMessage == 'msg1'">
                  All questions in the section break will be deleted.<br /><br />
                  Delete section break?
                </div>
                <div class="child-cont-2" *ngIf="deleteMessage == 'msg2'">
                  This section break will be deleted, because there are no
                  questions left. <br /><br />Delete Question?
                </div>
                <div class="child-cont-2" *ngIf="deleteMessage == 'msg3'">
                  All instances of the question will be deleted from the other
                  tests. <br /><br />
                  Delete question?
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer-new">
            <app-button
              class="align-left"
              buttonText="Cancel"
              [purpose]="_buttonPurpose.Secondary"
              data-dismiss="modal"
              (click)="closeDeleteModal()"
              style="padding-left: 24px"
            ></app-button>
            <app-button
              buttonText="Yes"
              [purpose]="_buttonPurpose.Primary"
              data-dismiss="modal"
              (click)="closeConfirmModal()"
              style="padding-left: 3px"
            ></app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<preview-modal-component
  *ngIf="closeModalPopUp"
  [header]="Preview"
  [preview-data]="previewUrl"
  [question-index]="qIndex"
  (closeModal)="closeModal($event)"
></preview-modal-component>

<preview-modal-component
  *ngIf="isPreviewSourceQuestions"
  [sourceLocationInfo]="'SourcePanel'"
  [preview-data]="questionListKebab"
  [header]="previewHeaderText"
  [question-index]="questionIndex"
  (addQuestionClicked)="addQuestionClicked($event)"
  (closeModal)="closeModal($event)"
>
</preview-modal-component>
<div class="shortcuts-modal">
  <app-shared-modal
    titleText="Keyboard shortcuts for adding and reordering questions"
    [isOpen]="shortcutsModalIsVisible"
    [panelClass]="'keyboard-shortcuts-modal'"
    cancelButtonText="Close"
    confirmButtonText=""
    (show)="shortcutsModalIsVisible = true"
    (close)="shortcutsModalIsVisible = false"
    (cancel)="shortcutsModalIsVisible = false"
  >
  <ul class="keyboard-shortcuts pl-0" role="list" aria-label="Keyboard shortcuts">
    <li class="shortcut-row" role="listitem">
      <span class="shortcut-key-group">
        <span class="shortcut-key modifier-key" aria-hidden="true">Space</span>
        <span class="combination-text" aria-hidden="true">or</span>
        <span class="shortcut-key modifier-key" aria-hidden="true">Enter</span>
        <span class="sr-only">Space or Enter key</span>
      </span>
      <span class="shortcut-desc">Select an item to "drag"</span>
    </li>
    <li class="shortcut-row" role="listitem">
      <span class="shortcut-key-group">
        <span class="shortcut-key modifier-key" aria-hidden="true">{{isMacOS ? 'Cmd' : 'Ctrl'}}</span>
        <span class="combination-text" aria-hidden="true">+</span>
        <span class="shortcut-key non-modifier-key" aria-hidden="true">&#8593;</span>
        <span class="shortcut-key non-modifier-key" aria-hidden="true">&#8595;</span>
        <span class="sr-only">{{ (isMacOS ? 'Command' : 'Control') + ' plus up or down arrow' }}</span>
      </span>
      <span class="shortcut-desc">Move item (within Your Test Section)</span>
    </li>
    <li class="shortcut-row" role="listitem">
      <span class="shortcut-key-group">
        <span class="shortcut-key modifier-key" aria-hidden="true">{{isMacOS ? 'Cmd' : 'Ctrl'}}</span>
        <span class="combination-text" aria-hidden="true">+</span>
        <span class="shortcut-key non-modifier-key" aria-hidden="true">&#8594;</span>
        <span class="sr-only">{{ (isMacOS ? 'Command' : 'Control') + ' plus right arrow' }}</span>
      </span>
      <span class="shortcut-desc">Move item from Add From Section to Your Test Section</span>
    </li>
    <li class="shortcut-row" role="listitem">
      <span class="shortcut-key-group">
        <span class="shortcut-key modifier-key" aria-hidden="true">Space</span>
        <span class="combination-text" aria-hidden="true">or</span>
        <span class="shortcut-key modifier-key" aria-hidden="true">Enter</span>
        <span class="sr-only">Space or Enter key</span>
      </span>
      <span class="shortcut-desc">Drop/Confirm position</span>
    </li>
    <li class="shortcut-row" role="listitem">
      <span class="shortcut-key modifier-key" aria-hidden="true">Esc</span>
      <span class="shortcut-desc">Esc to cancel a move</span>
    </li>
  </ul>
  </app-shared-modal>
</div>